var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRookLogoBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_20697",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 20697",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 180,
    viewBox: "0 0 240 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_5345",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5345",
    width: 240,
    height: 180
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247870",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247870",
    d: "M116.639,0,30.161,32.631,104.8,60.792l2.116-13.766-6.487-5.969V23.831h6.487v6.531H113.4V23.831h6.486v6.531h6.485V23.831h6.486V41.058l-6.486,5.969,2.116,13.766,74.635-28.161Z",
    transform: "translate(3.232 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_20561",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 20561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_20560",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 20560",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247871",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247871",
    d: "M130.143,63.438l2.922,18.871,7.583,7.576v6.5s-14.082,3.248-23.831,3.248-23.83-3.248-23.83-3.248v-6.5l7.582-7.576,2.922-18.871L30.161,90.9l86.655,32.451L203.473,90.9Z",
    transform: "translate(3.054 6.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247872",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247872",
    d: "M126.3,165.684V152H110.914v13.679h-3.365V135.441h3.365v13.548H126.3V135.441h3.322v30.243Z",
    transform: "translate(10.89 13.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247873",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247873",
    d: "M157.143,150.822q0,8.083-2.579,11.712t-9.377,3.628q-6.8,0-9.378-3.717t-2.579-11.691q0-7.975,2.622-11.844t9.313-3.866q6.687,0,9.331,3.845t2.647,11.933m-20.459-.089q0,6.647,1.747,9.549t6.756,2.907q5.005,0,6.73-2.839t1.729-9.528q0-6.69-1.793-9.745t-6.709-3.063q-4.921,0-6.688,3.038t-1.772,9.681",
    transform: "translate(13.49 13.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247874",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247874",
    d: "M156.888,138.457v-3.016h21.857v3.016H169.52v27.226H166.2V138.457Z",
    transform: "translate(15.885 13.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247875",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247875",
    d: "M180.625,165.684V135.441h18.4v2.971H183.99v10.446h12.416v2.928H183.99V162.71h15.038v2.974Z",
    transform: "translate(18.289 13.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247876",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247876",
    d: "M219.23,165.684H202.575V135.441h3.364v27.228H219.23Z",
    transform: "translate(20.511 13.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247877",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247877",
    d: "M4.85,154.854v10.664H0V135.58H11.364q10.141,0,10.143,9.528,0,6.382-4.9,8.654l4.939,11.755H16.216l-4.328-10.664Zm11.672-9.7q0-5.377-5.158-5.377H4.85v10.884h6.6a4.665,4.665,0,0,0,3.848-1.508,6.143,6.143,0,0,0,1.223-4",
    transform: "translate(0 13.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247878",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247878",
    d: "M45,162.37q-2.689,3.67-9.465,3.671t-9.485-3.693q-2.711-3.691-2.711-11.6t2.732-11.755q2.732-3.846,9.464-3.845t9.442,3.823q2.711,3.825,2.71,11.777T45,162.37m-15.148-3.148q1.487,2.581,5.682,2.579t5.663-2.532q1.462-2.534,1.464-8.5t-1.509-8.679q-1.507-2.7-5.617-2.71t-5.638,2.71q-1.531,2.712-1.531,8.633t1.487,8.5",
    transform: "translate(2.363 13.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247879",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247879",
    d: "M71.041,162.37q-2.689,3.67-9.465,3.671t-9.485-3.693q-2.711-3.691-2.711-11.6t2.732-11.755q2.732-3.846,9.464-3.845t9.442,3.823q2.711,3.825,2.71,11.777T71.041,162.37m-15.148-3.148q1.487,2.581,5.682,2.579t5.663-2.532q1.462-2.534,1.464-8.5t-1.509-8.679q-1.507-2.7-5.618-2.71t-5.638,2.71q-1.531,2.712-1.531,8.633t1.487,8.5",
    transform: "translate(5 13.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247880",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247880",
    d: "M81.46,165.517H76.608V135.58H81.46v13.505l4.461-.352,6.119-13.153h5.554L90.2,150.614l7.694,14.9H92.259l-6.339-12.5-4.461.305Z",
    transform: "translate(7.757 13.699)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRookLogoBig);
export default __webpack_public_path__ + "static/media/rook-logo-big.d0abd8c74a4a7d5e9136aea02e7556e4.svg";
export { ForwardRef as ReactComponent };